// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.chat_message_role_enum */
var ChatMessageRoleEnum;
(function (ChatMessageRoleEnum) {
    ChatMessageRoleEnum["user"] = "user";
    ChatMessageRoleEnum["assistant"] = "assistant";
})(ChatMessageRoleEnum || (ChatMessageRoleEnum = {}));
;
export default ChatMessageRoleEnum;
/** Zod schema for chat_message_role_enum */
export const chatMessageRoleEnum = z.nativeEnum(ChatMessageRoleEnum);
//# sourceMappingURL=ChatMessageRoleEnum.js.map